import Vue from 'vue';
import Clipboard from 'clipboard'
import { Toast } from 'vant';

Vue.prototype.copyWord = (e) => {
    let clipboard = new Clipboard(e.target);
    clipboard.on('success', function () {
        Toast("复制成功")
    });
    clipboard.on('error', function () {
        Toast("复制失败")
    });
    // 解决第一次点击不生效的问题，如果没有，第一次点击会不生效
    clipboard.onClick(e)
}